/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Table,
  Space,
  Spin,
  Tooltip,
  Button,
  Empty,
  DatePicker,
  message,
  Select,
  Row,
  Col,
  Card
} from "antd";
import { serialNum } from "../../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import {
  capitaliseWithHyphen,
  dateFormat_dmy,
  commonSorterForTable,
} from "../../../utils";

import urls from "../../../api/urls";
import API from "../../../api";
import printerIcon from "../../../assests/images/printIcon.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import UpdateIcon from "../../../assests/images/updateEway.svg";
import moment from "moment";

import search_icon from "../../../assests/images/search-icon.svg";

import "../InScan/style.scss";

const styles = `
  .cp-select-wrapper {
    .ant-select-selector {
      padding: 4px 11px !important;
      height: 40px !important;
      display: flex;
      align-items: center;
    }

    .ant-select-selection-item {
      display: flex;
      align-items: center;
    }

    .cp-name {
      font-size: 14px;
      color: #333;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .cp-count-badge {
      background: #f0f0f0;
      padding: 2px 8px;
      border-radius: 10px;
      font-size: 12px;
      color: #666;
      margin-left: 8px;
      min-width: 24px;
      text-align: center;
    }

    .ant-select-item {
      padding: 8px 12px !important;
    }

    .ant-select-item-option-content {
      width: 100%;
    }
  }
`;

const CpWiseManifest = () => {
  const { MANIFEST_CP_LIST, CP_WISE_MANIFEST } = urls;
  const { RangePicker } = DatePicker;
  const { Option } = Select;


  const navigate = useNavigate();
  const location = useLocation();
  const [allCps, setAllCps] = useState([]);
  const [manifestDetails, setManifestDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentCpId, setCurrentCpId] = useState(null);
  const [lastDate, setLastDate] = useState({});
  const [dateRangeStatus, setDateRangeStatus] = useState(false);
  const [sortedInfo, setSortedInfo] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  // Default date values
  const defaultStartDate = moment().subtract(1, "day").format(dateFormat_dmy);
  const defaultEndDate = moment().format(dateFormat_dmy);
  const defaultDateRange = {
    fromDate: defaultStartDate,
    toDate: defaultEndDate
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    const { current, pageSize } = pagination;

    // Update pagination state and reset to first page if page size changes
    setPagination(prev => {
      const newCurrent = prev.pageSize !== pageSize ? 1 : current;
      return {
        ...prev,
        current: newCurrent,
        pageSize
      };
    });

    // Get the new current page after state update
    const newCurrent = pagination.pageSize !== pageSize ? 1 : current;

    getManifestDetails(
      lastDate?.fromDate || moment().subtract(1, "day").format(dateFormat_dmy),
      lastDate?.toDate || moment().format(dateFormat_dmy),
      newCurrent - 1,
      pageSize,
      currentCpId
    );
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(pagination.pageSize, pagination.current, idx),
    },
    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      key: "manifestId",
      width: 10,

      render: (text) => <span>{text}</span>,
    },
    {
      title: "CP Name",
      dataIndex: "cpName",
      key: "cpName",
      width: 10,
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 10,
      sorter: (a, b) => commonSorterForTable(a, b, "date"),
      sortOrder: sortedInfo?.columnKey === "date" ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text) => {
        let parsedDate = moment(text, "YYYY-MM-DD HH:mm:ss");
        let formattedDate = parsedDate?.format("DD-MM-YYYY HH:mm:ss");
        return <div>{formattedDate ? formattedDate : null}</div>;
      },
    },
    {
      title: "No of Shipment(s)",
      width: 10,
      dataIndex: "shipmentCount",
      key: "shipmentCount",
    },
    {
      title: "Total Weight (Kg)",
      dataIndex: "totalWeight",
      key: "totalWeight",
      width: 10,
      render: (text) => <span>{text?.toFixed(2)}</span>,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 20,
      render: (text, record) => (
        <Space size="middle">
          <Button
            className=""
            disabled={!record?.isEwayBillPresent}
            style={{
              borderRadius: "5px",
              color: !record?.isEwayBillPresent ? "#919090" : "#2E77D0",
              background: !record?.isEwayBillPresent ? "#EEEEEE" : "white",
              border: "1px solid",
              padding: "2px 4px",
            }}
            onClick={() =>
              navigate("/cp-wise-Eway/" + record?.manifestId, {
                state: {
                  ...record,
                  cpId: currentCpId,
                  dateRange: lastDate,
                },
              })
            }
          >
            <img src={UpdateIcon} />
            <span className="ml-1 fw-500">E-WAY BILL UPDATE</span>
          </Button>
          <Button
            className=""
            style={{
              borderRadius: "5px",
              color: !record?.isEwayBillPresent ? "#919090" : "#2E77D0",
              background: !record?.isEwayBillPresent ? "#EEEEEE" : "white",
              border: "1px solid",
              padding: "2px 4px",
            }}
            disabled={!record?.isEwayBillPresent}
            onClick={() =>
              navigate("/print-eway-bill", {
                state: {
                  state: record?.manifestId,
                  key: "VIEW_TRIP",
                  slug: "/generateManifest?tab=2",
                  isCP_EwayBill: true,
                  cpId: currentCpId,
                  dateRange: lastDate,
                },
              })
            }
          >
            <span className="fw-500">PRINT</span>
          </Button>
          <Button
            onClick={() =>
              navigate("/cp-wise-manifest-print/" + record?.manifestId, {
                state: {
                  ...record,
                  cpId: currentCpId,
                  dateRange: lastDate,
                },
              })
            }
          >
            <Tooltip title="Print">
              <img src={printerIcon} />
            </Tooltip>
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getCPDetails();
  }, []);

  // Always reset to defaults on mount (remount)
  useEffect(() => {
    setCurrentCpId(null);
    setLastDate({});
    setDateRangeStatus(false);
    setSortedInfo({});
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0
    });
  }, []);

  // Restore state from navigation (if present), otherwise always set defaults when CPs are loaded
  useEffect(() => {
    if (location.state && !location.state.forceDefault) {
      if (location.state.cpId) {
        setCurrentCpId(location.state.cpId);
      }
      if (location.state.dateRange) {
        setLastDate(location.state.dateRange);
        setDateRangeStatus(true);
      }
    } else if (allCps?.length > 0) {
      // Always set defaults if no navigation state
      const defaultCpId = allCps[0]?.cpId;
      setCurrentCpId(defaultCpId);
      setLastDate(defaultDateRange);
      setDateRangeStatus(true);
      if (defaultCpId) {
        getManifestDetails(defaultStartDate, defaultEndDate, 0, pagination.pageSize, defaultCpId);
      }
    }
    // eslint-disable-next-line
  }, [allCps, location.state]);

  useEffect(() => {
    // Only set defaults and call getManifestDetails if currentCpId is not already set
    if (allCps?.length > 0 && currentCpId == null) {
      const defaultCpId = allCps[0]?.cpId;
      setCurrentCpId(defaultCpId);
      setLastDate(defaultDateRange);
      setDateRangeStatus(true);
      if (defaultCpId) {
        getManifestDetails(defaultStartDate, defaultEndDate, 0, pagination.pageSize, defaultCpId);
      }
    }
    // If state was restored, fetch data for it
    if (allCps?.length > 0 && currentCpId && lastDate?.fromDate && lastDate?.toDate) {
      getManifestDetails(lastDate.fromDate, lastDate.toDate, 0, pagination.pageSize, currentCpId);
    }
    // eslint-disable-next-line
  }, [allCps, currentCpId, lastDate]);

  // Handle pagination changes
  useEffect(() => {
    if (pagination.current > 1 && manifestDetails.length === 0) {
      // If we"re on a page > 1 but have no data, reset to page 1
      setPagination(prev => ({ ...prev, current: 1 }));
    }
  }, [manifestDetails.length, pagination.current]);

  const getManifestDetails = async (
    start = defaultStartDate,
    end = defaultEndDate,
    page = 0,
    size = 10,
    cpId = currentCpId
  ) => {
    setLoading(true);
    try {
      const formattedStartDate = moment(start, dateFormat_dmy).format("DD-MM-YYYY");
      const formattedEndDate = moment(end, dateFormat_dmy).format("DD-MM-YYYY");

      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      let queryParams = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&page=${page}&size=${size}&hubId=${hubId}`;
      if (cpId) {
        queryParams += `&cpId=${cpId}`;
      }

      let response = await API.Api(
        `${CP_WISE_MANIFEST}?${queryParams}`
      ).getWithPremiseHeader();

      if (response?.status) {
        const { manifests, totalCount } = response?.response?.data || {};
        setManifestDetails(manifests || []);

        // Update pagination state with correct current page and total
        setPagination(prev => ({
          ...prev,
          current: page + 1, // Convert 0-based page to 1-based for display
          total: totalCount
        }));
      } else {
        message.error(response?.response?.data?.message || "Internal server error.");
      }
    } catch (error) {
      message.error("Failed to fetch manifest details");
    } finally {
      setLoading(false);
    }
  };

  const getCPDetails = async () => {
    setLoading(true);
    try {
      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      let response = await API.Api(
        MANIFEST_CP_LIST + hubId
      ).getWithHeader();

      if (response?.status) {
        let data = response?.response?.data;
        setAllCps(data);
      } else {
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    } catch (error) {
      message.error("Failed to fetch CP details");
    } finally {
      setLoading(false);
    }
  };

  const onChangeHandle = (value) => {
    const cpId = value;
    setCurrentCpId(cpId);

    // Reset pagination to first page
    setPagination(prev => ({
      ...prev,
      current: 1
    }));

    getManifestDetails(
      lastDate?.fromDate || defaultStartDate,
      lastDate?.toDate || defaultEndDate,
      0,
      pagination.pageSize,
      cpId
    );
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const dateRangeHandle = (e, a) => {
    const newDateRange = {
      fromDate: a[0] || "",
      toDate: a[1] || ""
    };
    setLastDate(newDateRange);
    setDateRangeStatus(a[0]?.length > 0);

    // Reset pagination to first page when date range changes
    setPagination(prev => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <style>{styles}</style>
      <div className="cp-wise-manifest-cntr" style={{ minHeight: "400px" }}>
        <Spin
          spinning={loading}
          indicator={
            <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
          }
        >
          <Card>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="cp-select-wrapper" style={{ width: "100%", maxWidth: "300px" }}>
                  <Select
                    style={{
                      width: "100%",
                      height: "40px"
                    }}
                    placeholder="Select CP"
                    value={currentCpId}
                    onChange={onChangeHandle}
                    optionFilterProp="children"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownStyle={{
                      minWidth: "250px",
                      maxHeight: "300px"
                    }}
                    dropdownMatchSelectWidth={false}
                    optionLabelProp="label"
                  >
                    {allCps?.map((item) => (
                      <Option
                        key={item?.cpId}
                        value={item?.cpId}
                        label={capitaliseWithHyphen(item?.cpName)}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <div className="cp-name">{capitaliseWithHyphen(item?.cpName)}</div>
                          {/* <div className="cp-count-badge">{item?.noOfManifest}</div> */}
                        </div>
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
              <Col xs={24} sm={12} md={16} lg={18}>
                <div className="d-flex justify-content-end">
                  <RangePicker
                    style={{
                      borderRadius: "5px 0 0 5px",
                      height: "40px",
                      width: "230px",
                    }}
                    disabledDate={(current) => disabledDate(current)}
                    onChange={dateRangeHandle}
                    value={[
                      lastDate?.fromDate ? moment(lastDate.fromDate.replaceAll("-", "/"), dateFormat_dmy) : null,
                      lastDate?.toDate ? moment(lastDate.toDate.replaceAll("-", "/"), dateFormat_dmy) : null
                    ]}
                    format={dateFormat_dmy}
                  />
                  <Button
                    className="center"
                    disabled={!dateRangeStatus}
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "0 5px 5px 0",
                    }}
                    onClick={() => {
                      // Reset pagination to first page
                      setPagination(prev => ({ ...prev, current: 1 }));
                      getManifestDetails(
                        lastDate?.fromDate || defaultStartDate,
                        lastDate?.toDate || defaultEndDate,
                        0,
                        pagination.pageSize,
                        currentCpId
                      );
                    }}
                  >
                    <img src={search_icon} />
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>

          {manifestDetails?.length > 0 ? (
            <Table
              key={`table-${currentCpId}-${lastDate?.fromDate}-${lastDate?.toDate}`}
              onChange={handleTableChange}
              className="table-head-sticky"
              columns={columns}
              dataSource={manifestDetails}
              pagination={{
                ...pagination,
                showSizeChanger: true,
                showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
                pageSizeOptions: ["10", "20", "50", "100"],
                position: ["bottomRight"]
              }}
              rowKey="manifestId"
            />
          ) : (
            <Empty description="No manifest data found" />
          )}
        </Spin>
      </div>
    </>
  );
};

export default CpWiseManifest;
